import { useEffect } from "react"
import Lenis from "@studio-freight/lenis"

function SmoothScroll(){

useEffect(()=>{

const lenis = new Lenis({
lerp: 0.1,
wheelMultiplier: 1,
smoothWheel: true,
smoothTouch: false
})

let rafId

function raf(time){
lenis.raf(time)
rafId = requestAnimationFrame(raf)
}

rafId = requestAnimationFrame(raf)

const onVisibilityChange = () => {
if (document.hidden) cancelAnimationFrame(rafId)
else rafId = requestAnimationFrame(raf)
}

document.addEventListener("visibilitychange", onVisibilityChange)

return () => {
cancelAnimationFrame(rafId)
document.removeEventListener("visibilitychange", onVisibilityChange)
lenis.destroy()
}

},[])

return null

}

export default SmoothScroll